import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environment";
import { Observable } from "rxjs";
import {
  CorpListItem,
  Corporation,
} from "../../features/corporation-management/interfaces/corporation.interface";
import { DropdownItemWithDate } from "../interfaces/dropdown-item.interface";
import { ListResponse } from "../interfaces/list-response.interface";
import { sanitizeParams } from "../sanitize-params";
import { LabourHours } from "../interfaces/labour-hours.interface";
import { ProductivityBenchmark } from "../interfaces/Productivity.interface";
@Injectable({ providedIn: "root" })
export class CorporationClient {
  endpoint = "corporation";
  constructor(private httpClient: HttpClient) {}

  getCorporationsDropdown(): Observable<DropdownItemWithDate[]> {
    return this.httpClient.get<DropdownItemWithDate[]>(
      `${environment.endpoint}/${this.endpoint}/dropdown`
    );
  }

  getCorporations(filters: {
    searchBy?: string;
    keyword?: string;
    includeDisabled?: boolean;
    includeDeleted?: boolean;
    page?: number;
    length?: number;
    sortBy?: string;
    sortDir?: string;
  }): Observable<ListResponse<CorpListItem>> {
    const params = sanitizeParams(filters) as Record<string, any>;

    return this.httpClient.get<ListResponse<CorpListItem>>(
      `${environment.endpoint}/${this.endpoint}/list`,
      { params }
    );
  }

  getCorporation(corpId: string): Observable<Corporation> {
    return this.httpClient.get<Corporation>(
      `${environment.endpoint}/${this.endpoint}/get/${corpId}`
    );
  }

  createCorp(corp: Corporation): Observable<any> {
    return this.httpClient.post<Corporation>(
      `${environment.endpoint}/${this.endpoint}/add`,
      corp
    );
  }

  updateCorp(corp: any): Observable<any> {
    return this.httpClient.put<Corporation>(
      `${environment.endpoint}/${this.endpoint}/edit`,
      corp
    );
  }

  deleteCorporation(corpId: string) {
    return this.httpClient.delete(
      `${environment.endpoint}/${this.endpoint}/delete/${corpId}`
    );
  }

  enableCorporation(corpId: string) {
    return this.httpClient.put(
      `${environment.endpoint}/${this.endpoint}/enabled/${corpId}`,
      null
    );
  }

  disableCorporation(corpId: string) {
    return this.httpClient.put(
      `${environment.endpoint}/${this.endpoint}/disabled/${corpId}`,
      null
    );
  }

  getLabourHours(corpId: string) {
    return this.httpClient.get<LabourHours>(
      `${environment.endpoint}/${this.endpoint}/get-labourhours/${corpId}`
    );
  }
  getOverTime(corpId: string) {
    return this.httpClient.get<LabourHours>(
      `${environment.endpoint}/${this.endpoint}/get-overtime/${corpId}`
    );
  }

  getProductivity(corpId: string) {
    return this.httpClient.get<ProductivityBenchmark[]>(
      `${environment.endpoint}/${this.endpoint}/get-productivitybenchmarks/${corpId}`
    );
  }
}
